import React, { useEffect, useState } from 'react';
import { useMap } from 'react-map-gl';
import "./BottomButtons.css";
import { MAP_STYLES } from "../InitMap/MapConfig";
import { useTranslation } from 'react-i18next';

export default function DarkModeButton() {

    const {t} = useTranslation("nbhd");

    const [darkOn, toggleDark] = useState(false);
    const map = useMap()

    const toggle = () => {
        toggleDark(!darkOn);
    }

    useEffect(() => {
        if (!map.current){
            return;
        }
        if (darkOn) {
            map.current.getMap().setStyle(MAP_STYLES["darkMode"].uri);
        } else {
            map.current.getMap().setStyle(MAP_STYLES["streets"].uri);
        }
    }, [darkOn, map])

    return <>
        <div id='dark-mode-legend' className={`legend_btn ${darkOn ? "dark-active" : ""}` } onClick={() => toggle()} >
            {t("nbhd.legend.dark")}
        </div>
    </>;
}
